import { apiSlice } from './apiSlice';

const validateStatus = (response, result) =>
  response.status === 200 && !result.isError;

// The staff dashboard (Safety Monitors and Admins). The backend scopes every
// endpoint to the Operators the signed-in user holds a role for.
export const backendApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getLiveActivities: builder.query({
      query: () => ({
        url: `/backend/live-activities`,
        method: 'GET',
        validateStatus,
      }),
    }),
    getActivityById: builder.query({
      query: (activityId) => ({
        url: `/backend/activity-detail/${activityId}`,
        method: 'GET',
        validateStatus,
      }),
    }),
    getStaffActivityComments: builder.query({
      query: (activityId) => ({
        url: `/backend/activity-detail/${activityId}/comments`,
        validateStatus,
      }),
    }),
    createStaffActivityComment: builder.mutation({
      query: ({ activity_id, ...comment }) => ({
        url: `/backend/activity-detail/${activity_id}/comments`,
        method: 'POST',
        body: comment,
        validateStatus,
      }),
    }),
    getStaffActivityContacts: builder.query({
      query: (activityId) => ({
        url: `/backend/activity-detail/${activityId}/contacts`,
        validateStatus,
      }),
    }),
    createStaffActivityContact: builder.mutation({
      query: ({ activity_id, ...contact }) => ({
        url: `/backend/activity-detail/${activity_id}/contacts`,
        method: 'POST',
        body: contact,
        validateStatus,
      }),
    }),
  }),
});

export const {
  useGetLiveActivitiesQuery,
  useGetActivityByIdQuery,
  useGetStaffActivityCommentsQuery,
  useCreateStaffActivityCommentMutation,
  useGetStaffActivityContactsQuery,
  useCreateStaffActivityContactMutation,
} = backendApiSlice;
